import { logger, metrics } from './slardar-utils'

const handleError = (
  err: Error,
  config?: {
    req?: any
    level?: 'warn' | 'info' | 'log' | 'error'
  }
) => {
  const { req, level = 'error' } = config || {}
  if (req?.metrics?.emitCounter && req.logger) {
    req.metrics.emitCounter('catch.error', 1, undefined, {
      errorType: err?.name || 'unknown',
    })
    req.logger[level](`[catch error] catched error. err = ${err?.stack}`)
  } else {
    metrics.counter('catch.error', {
      errorType: err?.name || 'unknown',
    })
    logger[level](`[catch error] catched error. err = ${err?.stack}`)
  }
}

export default handleError
